/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

export const StyledMarkCompleteBtn = styled(NeuButton)`
  color: #467d20 !important;
  border-color: #467d20 !important;
  --hover: rgb(211, 233, 194) !important;
`;
